export const cancelablePromise = (promise, abortController) => {
    promise.cancel = () => {
        abortController.abort();
    };
    return promise;
};
